import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { CommonService } from 'src/app/core/_services/common.service';
import { NgxGalleryOptions } from '@kolkov/ngx-gallery';
import { NgxGalleryImage } from '@kolkov/ngx-gallery';
import { NgxGalleryAnimation } from '@kolkov/ngx-gallery';
import { MainService } from 'src/app/core/_services/main.service';
import { API_ROUTES } from 'src/app/core/_constants/api-route.constant';
import { LocalStorageProvider } from 'src/app/core/_services/storage.service';
@Component({
  selector: 'app-review-detail-carousel',
  templateUrl: './review-detail-carousel.component.html',
  styleUrls: ['./review-detail-carousel.component.scss']
})
export class ReviewDetailCarouselComponent implements OnInit {
  @Input() activeEstimate: any
  @Input() allEstimates: any
  @Input() inspection: boolean = false;
  @Output() priceShow = new EventEmitter<boolean>();
  @Output() lumpSumShow = new EventEmitter<boolean>();
  @Output() approveAllEstimates = new EventEmitter<boolean>();
  @Output() pay = new EventEmitter<boolean>();

  @Input() workOrder: boolean = false;
  @Input() oppData: any;

  index: number = 0;
  hidePrice: boolean = true;
  galleryOptions: NgxGalleryOptions[] = [];
  galleryImages: any = [];
  isPreferredUser: boolean = false;

  constructor(private commonService: CommonService, private service: MainService,
    private storageService: LocalStorageProvider

  ) { }

  ngOnChanges(changes: SimpleChanges): void {
  }

  ngOnInit(): void {
    this.isPreferredUser = this.storageService.getItem('CurrentUser')?.externalCompanyData?.isPreferred;
    this.getDefaultStatus();
    this.getActiveEstimate();
    if (this.allEstimates[0].isToggleOn) {
      this.hidePrice = true;
      this.priceShow.emit(true);
    } else {
      this.hidePrice = false;
      this.priceShow.emit(false);
    }
    if (this.allEstimates[0].isLumpSum) {
      this.lumpSum = true;
      this.lumpSumShow.emit(true);
    } else {
      this.lumpSum = false;
      this.lumpSumShow.emit(false);
    }
    this.galleryOptions = [
      {
        width: '100%',
        height: '400px',
        preview: true,
        closeIcon: 'close',
        thumbnailsColumns: 4,
        imageAnimation: NgxGalleryAnimation.Slide,
        previewCloseOnEsc: true,
        previewCloseOnClick: true,
        imageArrows: true,
        previewKeyboardNavigation: true,
        imageArrowsAutoHide: true,
        thumbnailsArrows: true,
        previewZoom: true,
        thumbnailsRemainingCount: false,
        previewArrows: true,
        arrowPrevIcon: 'prev-arrow',
        arrowNextIcon: 'next-arrow',

      },
      // max-width 800
      {
        breakpoint: 800,
        width: '100%',
        height: '400px',
        imagePercent: 80,
        thumbnailsPercent: 20,
        thumbnailsMargin: 20,
        thumbnailMargin: 10,
        thumbnailsColumns: 3,
      },
      // max-width 400
      {
        breakpoint: 400,
        preview: true,
        thumbnailsColumns: 2,

      }
    ];
    this.setGalleryItems();
  }

  setGalleryItems() {
    // this.galleryImages = this.activeEstimate.itemImage.map((item: any) => ({ image: item.link, medium: item.link, big: item.link, isDefault: item.isDefault }))
    const images = this.activeEstimate.itemImage.filter(item => this.isImage(item.link))
      .map(item => ({ image: item.link, thumbImage: item.link, title: '' }));

    const videos = this.activeEstimate.itemImage.filter(item => this.isVideo(item.link))
      .map(item => ({ video: item.link, thumbImage: item.link, title: '' }));

    this.galleryImages = [...images, ...videos];
  }

  isImage(link: string): boolean {
    const imageExtensions = ['jpg', 'jpeg', 'png', 'gif'];
    return imageExtensions.some(ext => link.toLowerCase().endsWith(ext));
  }

  isVideo(link: string): boolean {
    const videoExtensions = ['mp4', 'avi', 'mov', 'wmv'];
    return videoExtensions.some(ext => link.toLowerCase().endsWith(ext));
  }

  setActiveEstimate(index: any) {
    this.commonService.setActiveEstimate(this.allEstimates[index]);
    this.getActiveEstimate();
  }
  getActiveEstimate() {
    this.commonService.activeEstimate$.subscribe(async activeEstimate => {
      if (activeEstimate) {
        this.activeEstimate = await activeEstimate;
        this.index = this.setIndex(activeEstimate?._id);
        this.getDefaultStatus(activeEstimate?.inspectionId);
        // this.setImage(this.activeEstimate?.itemImage[0],this.index);
        this.setGalleryItems();
      }
    });
  }
  activeEstimateStatus: any
  getDefaultStatus(id?: any) {
    this.service.get({}, `${API_ROUTES.OPPORTUNITY.getInspectionBtnStatus}`).pipe().subscribe(response => {
      if (response.status) {
        let initialData = response.data?.list;
        this.inspectionBtn = initialData;
        let foundEstimate = initialData.find((x) => x?._id == id);
        if (foundEstimate) {
          this.activeEstimateStatus = foundEstimate.fieldName;
        } else {
          this.activeEstimateStatus = ''
          console.log('Estimate not found for id:', id);
        }
      }

    })
  }
  setIndex(id: any) {
    return this.allEstimates.map((object: any) => object._id).indexOf(id);
  }

  showLightbox(index) {
    this.currentIndex = index;
    this.showFlag = true;
  }

  previous() {
    this.index--;
    this.setActiveEstimate(this.index);
  }
  next() {
    this.index++;
    this.setActiveEstimate(this.index);
  }
  setStatus() {
    switch (this.activeEstimate.inspectionStatus) {
      case 'Pass':
        return 'pass-status';
      case 'Pending':
        return 'pend-status';
      case 'Fail':
        return 'fail-status';
      default:
        return 'null-status';
    }
  }
  lumpSum: boolean = false;
  hidePriceDetails(e: any, type?: string) {
    if (type) {
      this.lumpSum = e.checked;
      this.lumpSumShow.emit(e.checked);
    } else {
      this.hidePrice = e.checked;
      this.priceShow.emit(e.checked);
    }
  }

  openPaymentPopUp() {
    this.pay.emit(true);
  }

  appEstimates() {
    this.approveAllEstimates.emit(true);
  }

  currentIndex: number = -1;
  showFlag: any = false;

  closeEventHandler() {
    this.showFlag = false;
    this.currentIndex = -1;
  }

  selectedOption: 'lumpSum' | 'dollar' | null = null;

  toggleOption(option: 'lumpSum' | 'dollar') {
    this.selectedOption = this.selectedOption === option ? null : option;

    // Your logic if needed
    if (this.selectedOption === 'lumpSum') {
      this.hidePriceDetails({ checked: true }, 'lS');
      this.hidePriceDetails({ checked: false });
    } else if (this.selectedOption === 'dollar') {
      this.hidePriceDetails({ checked: true });
      this.hidePriceDetails({ checked: false }, 'lS');
    } else {
      this.hidePriceDetails({ checked: false });
      this.hidePriceDetails({ checked: false }, 'lS');
    }
  }
  inspectionBtn: any = []
  setInspectionStatus(id: number): string {
    console.log(id);
    const foundBtn = this.inspectionBtn?.find(ele => ele?._id === id);
    // console.log(foundBtn, 'nwknkjwn')
    if (foundBtn) {
      // Apply class based on originalName
      switch (foundBtn.originalName) {
        case 'Fail':
          return 'red-btn';
        case 'Pass':
          return 'pass-status';
        case 'Pending':
          return 'pend-status';
        case 'N/A':
          return 'grey-btn';
        default:
          return '';
      }
    } else {
      return ''; // Default class if no button is found
    }
  }
}
